import axios from 'axios'
import router from '../router'
import store from '../store'


const instance =  axios.create({
    baseURL: process.env.VUE_APP_BASE_URL,
    timeout: 40000

})


instance.interceptors.request.use(
    config => {
      // if (!config.headers.Authorization) {
        const token = localStorage.getItem('id_token')
        const useOldStorage = localStorage.getItem('useOldReportStorage')
  
        if (token)
          config.headers.Authorization = `Bearer ${token}`

        if (useOldStorage)
            config.headers['X-UseOldReportStorage'] = useOldStorage
      // }
      return config
    }, error => Promise.reject(error)
  )

instance.interceptors.response.use(function (response) {
    return response;
}, function (error) {
    if (error.response && 401 === error.response.status) {
      store.dispatch('auth/logout')
      router.push({name: 'home', query: {msg: 'Ikke autentisert'}})
    } else {
        return Promise.reject(error);
    }
});

  export default instance